import AddIcon from "@mui/icons-material/Add";
import { Grid, Link } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
import { FieldTitle, useRedirect, useRefresh } from "react-admin";
import { useNavigate } from "react-router-dom";
import sendRequest from "../dataProvider/sendRequest";
import CustomButtonCancel from "../unit/CustomButtonCancel";
import PaperComponent from "../unit/PaperComponent";
import useNotify from "../unit/useNotify";
export default function ProductCreate({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const [submitTitle, setSubmitTitle] = React.useState("Confirm");
  const [selectProductTypeId, setSelectProductTypeId] = React.useState("");
  const [selectProductName, setSelectProductName] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [formSubData, setFormSubData] = React.useState({});
  const navigate = useNavigate();
  const redirect = useRedirect();
  const refresh = useRefresh();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSubmitTitle("Confirm");
    setSelectProductTypeId("");
    setSelectProductName("");
    refresh();
  };

  const productPersonalType = [
    {
      id: "unsecured",
      name: "Unsecured Loan",
      child: [
        { id: "1", name: "Small and Simple" },
        { id: "2", name: "Employment Based" },
        { id: "19", name: "Purchase Finance" },
        { id: "3", name: "General Purpose" },
        { id: "10", name: "Refund Anticipation" },
      ],
    },
    {
      id: "secured",
      name: "Secured Loan",
      child: [
        { id: "5", name: "Mortgage" },
        { id: "6", name: "Purchase Car Loan" },
        { id: "11", name: "Refinance Car Loan" },
      ],
    },
    {
      id: "creditcard",
      name: "Credit Builder Loan",
      child: [
        { id: "4", name: "Single Term" },
        { id: "12", name: "Credit Building Ladder" },
      ],
    },
    {
      id: "revolving",
      name: "Revolving Credit",
      child: [{ id: "13", name: "Secured Credit Card" }],
    },
    {
      id: "smallbusiness",
      name: "Small Business Loan",
      child: [{ id: "18", name: "Micro Loan" }],
    },
    {
      id: "account",
      name: "Account Opening",
      child: [{ id: "7", name: "Depository Account" }],
    },
  ];

  const handleSelectProductType = (id: string, name: string) => async () => {
    setSelectProductTypeId(id);
    setSelectProductName(name);
    const formJson = {
      loantypeId: id,
    };
    const reqUrl = `products/actions/add`;
    const responseBack = await sendRequest(reqUrl, {
      id: 0,
      data: formJson,
    });
    console.log(responseBack.data);
    if (responseBack && responseBack.code == "200") {
      successNotify("New product created successfully, Please edit it");
      const newProductId = responseBack.id;

      redirect("edit", "products", newProductId);
      handleClose();
    } else {
      errorNotify(responseBack?.message || "Data not saved!");
    }
  };
  return (
    <React.Fragment>
      <Button
        id="btn-list-add-product"
        variant="text"
        color="primary"
        size="small"
        sx={{
          width: "120px",
          minWidth: "120px",
          color: "primary.main",
          "&.MuiButton-sizeSmall": {
            lineHeight: 1.5,
            fontSize: "0.875rem",
          },
        }}
        onClick={handleClickOpen}
      >
        <AddIcon sx={{ fontSize: "1.25rem" }} /> Product
      </Button>
      <Dialog
        id="dialog-product-add"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="md"
        sx={{ "& .MuiDialog-paper": { height: "45vh" } }}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        PaperProps={{
          component: "form",
          //   onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
          //     event.preventDefault();
          //     // const formData = new FormData(event.currentTarget);
          //     // const formJson = Object.fromEntries((formData as any).entries());
          //     // console.log("formJson =====>", formJson);
          //     const formJson = {
          //       subtypeId: selectProductTypeId,
          //     };
          //     setSubmitTitle("loading");
          //     const reqUrl = `products/add`;
          //     const responseBack = await sendRequest(reqUrl, {
          //       id: 0,
          //       data: formJson,
          //     });
          //     console.log(responseBack.data);
          //     if (responseBack && responseBack.code == "200") {
          //       successNotify("Data saved successfully");
          //       handleClose();
          //     } else {
          //       if (responseBack?.message != undefined) {
          //         errorNotify(responseBack.message);
          //       } else {
          //         errorNotify("Data not saved");
          //       }
          //     }
          //   },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            mb: 2,
            borderBottom: "1px solid #e5e5e5",
            color: "#465384",
            textTransform: "uppercase",
          }}
        >
          Add new product {selectProductName && <>: {selectProductName}</>}
        </DialogTitle>
        <DialogContent>
          <Box sx={{ minHeight: "200px", marginTop: "20px" }}>
            <DialogContentText>
              {selectProductName && (
                <>{selectProductName} Creating product... Please wait.</>
              )}
              {!selectProductName && (
                <Box>
                  <Grid container spacing={2}>
                    {productPersonalType.map((item, index) => (
                      <>
                        <Grid
                          item
                          xs={4}
                          key={
                            `productSection_` +
                            Math.random().toString(36).substring(2, 15)
                          }
                        >
                          <FieldTitle label={item.name} />
                          <Box>
                            {item.child.map((childItem, childIndex) => (
                              <>
                                <Link
                                  onClick={handleSelectProductType(
                                    childItem.id,
                                    childItem.name
                                  )}
                                  sx={{
                                    textDecoration: "none",
                                    fontSize: "1rem",
                                    cursor: "pointer",
                                  }}
                                  key={
                                    `productSection_link_` +
                                    Math.random().toString(36).substring(2, 15)
                                  }
                                >
                                  {childItem.name}
                                </Link>
                                <br />
                              </>
                            ))}
                          </Box>
                        </Grid>
                      </>
                    ))}
                  </Grid>
                </Box>
              )}
            </DialogContentText>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          {/* <CustomButtonSubmit
            label={submitTitle}
            variant="contained"
            disabled={submitTitle == "loading" ? true : false}
          /> */}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
